export default class FulfillmentLocation {
    /** x 축 */
    latitude = 0;
    /** y 축 */
    longitude = 0;
    /** 고도 */
    altitude = 0;
    /** 속도 */
    speed = 0;
    /** 방향 */
    bearing = 0;
    constructor(data) {
        Object.assign(this, data);
    }
}
